import classNames from "classnames";
import { PropsWithChildren } from "react";

interface ICardProps {
  className?: string;
}

const Card = ({ children, className }: PropsWithChildren<ICardProps>) => {
  return (
    <div
      className={classNames(
        "bg-white h-full w-full p-6 rounded-xl border border-[#E5E7EB] shadow-sm",
        className
      )}
    >
      {children}
    </div>
  );
};

export default Card;
